import {WixSdk} from '@wix/js-sdk-wrapper';
import {Reason} from '../../../typings/generic';
import {BI_ERRORS} from '../../logging/errors';
import {logError} from '../../logging/logging';

export function getUserSessionToken(): Promise<string> {
  return WixSdk.Activities.getUserSessionToken().catch((reason: Reason): string => {
    logError(BI_ERRORS.tpa.wix.activities.getUserSessionToken, {reason});
    const uid = WixSdk.Utils.getUid() || WixSdk.Utils.getInstanceValue('aid');
    return uid ? uid.replace(/-/g, '') : 'asaasasasasasasasasasasasasasasasa';
  });
}
